


































































































































   import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
   import Util from '@/lib/util';
    import AbpBase from '@/lib/abpbase';
    import AdjustItem from '@/store/entities/jm/adjustitem';
import Decimal from 'decimal.js';
    @Component
  export default class AuditAdjustCreateView extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    currentModel=new AdjustItem();
    formRef = "ajust-form";
    tableData=[];
    selvalue="";
    sumflag:boolean=false;
    isLoading:boolean=false;
    indexRow:string="";
    indexCol:string="";
    visibleChange(value) {
      if (!value) {
        (this.$refs[this.formRef] as any).resetFields();
        this.currentModel=new AdjustItem();
        this.tableData=[];
        this.$emit('input',false);
      }
    }
    formatCurrency (num) {
      return Util.format.amount(num);
    }
    adjRules= {
      adjno: [
        { required: true, message: '凭证号不能为空', trigger: 'blur' }
    ]}
    InputLimit(e){
      e.target.value = (e.target.value.match(/^-?\d*(\.?\d{0,1})/g)[0]) || null;
    }
    get itemList(){
      var data=[],child1=[],child2=[],child3=[];
      var lists=this.$store.state.assetsclass.listname;
      lists.forEach(item => {
          if(item.reportGrp==='1'){
            child1.push({'value':item.id,'label':item.itemName});
          }
          if(item.reportGrp==='2'){
            child2.push({'value':item.id,'label':item.itemName});
          }
          if(item.reportGrp==='3'){
            child3.push({'value':item.id,'label':item.itemName});
          }
      });
      data.push({'label':'资产项','children':child1});
      data.push({'label':'负债及权益','children':child2});
      data.push({'label':'损益项','children':child3});
      return data;
    }
    acctList(id){

      var data=[];
      var lists=this.$store.state.assetsclass.acctname;
      //console.log(id,lists);
      //data.push({'id':id,'acctId':'0','isLeaf':'0','itemName':''});
      lists.forEach(element => {
          if(element.id===id){
              data.push(element);
          }
      });
      return data;
    }
    cellClassName({row, column, rowIndex, columnIndex}){
        row.index = rowIndex;
        column.index = columnIndex;
    }
    cellClick(row,column,cell) {
      this.indexRow = row.index;
      this.indexCol = column.index;
      this.$nextTick(() => {
        if(column.index===3){
          if(this.$refs["dr"+this.indexRow]){
            (this.$refs["dr"+this.indexRow] as any).focus();
          }
        }
        if(column.index===4){
          if(this.$refs["cr"+this.indexRow]){
            (this.$refs["cr"+this.indexRow] as any).focus();
          }
        }
      });
    }
    updateData(e,index){
      if(e){
        //this.tableData[index].acctId=e;
        var lists=this.$store.state.assetsclass.acctname;
        try{
          lists.forEach(element => {
              if(element.acctId===e){
                this.tableData[index].itemName=element.itemName;
                throw Error();
              }
          });
        }
        catch(ex){}
      }
    }
    updateDR(e,index){
      let changeValue=e.target.value.replace(/,/g, '').replace(/\s+/g, '');
      if(!/^-?\d*\.?\d+$/.test(changeValue)){
        this.tableData[index].amtDR='0';
        this.$Message.error(this.L("JM.LimitedNumber")); 
      }
      else{
        this.tableData[index].amtDR=Number(changeValue).toFixed(2);
      }
      this.indexRow="";
      this.indexCol="";
    }
    updateCR(e,index){
      let changeValue=e.target.value.replace(/,/g, '').replace(/\s+/g, '');
      if(!/^-?\d*\.?\d+$/.test(changeValue)){
        this.tableData[index].amtCR='0';
        this.$Message.error(this.L("JM.LimitedNumber")); 
      }
      else{
        this.tableData[index].amtCR=Number(changeValue).toFixed(2);
      }
      this.indexRow="";
      this.indexCol="";
    }
    handleAdd(rid:any) {
      let row = {
        rId:rid,
        rName: "",
        acctId:"",
        itemName: "",
        description: "",
        amtDR: "0",
        amtCR: "0"
      }
      this.tableData.push(row) 
    }
    async setModalId(id){
       this.currentModel.adjid= id;
       await this.getdata();
    }
    handleDelete(index, row) {
      this.tableData.splice(index, 1)
    }
    async getdata(){
      let currid=this.$store.state.jobdo.currjob;
      let headid=this.currentModel.adjid;
      if(headid!=='0'){
        let result=await this.$store.dispatch({
          type:'fsadjustline/getitem',
          data:{id:headid,value:currid}
        });
        if(result.length>0){
          var data=[];
          this.currentModel.adjno=result[0]["adjNo"];
          this.currentModel.adjtype=result[0]["adjType"];
          this.currentModel.isposted=result[0]["isPosted"]=='1'?true:false;
          this.currentModel.createby=result[0]["updateBy"];
          this.currentModel.checkby=result[0]["checkBy"];
          result.forEach(item=>{
             data.push({ rId:item.rId,rName:'',acctId:item.acctId=='0'?'':item.acctId,itemName:item.itemName,description:item.description,amtDR:item.amtDR,amtCR: item.amtCR});
          });
          this.tableData=data;
        }
      } 
    }
    async getitem(){
      let currid=this.$store.state.jobdo.currjob;
      await this.$store.dispatch({
        type:'assetsclass/getItemName',
        data:currid
      })
    }
    async getacctname(){
      let currid=this.$store.state.jobdo.currjob;
      await this.$store.dispatch({
        type:'assetsclass/getDetailName',
        data:currid
      })
    }
    getAdjustSum(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index===0||index===1){
            sums[index]='';
            return;
          }
          if (index === 2) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = this.formatCurrency(sums[index].toFixed(2));
          } else {
            sums[index] = '';
          }
        });
        this.sumflag=sums[3]==sums[4]?true:false;
        return sums;
      }
    cancel(){
        (this.$refs[this.formRef] as any).resetFields();
        this.tableData=[];
        this.$emit('input',false);
    }
    async deladjust(id){
      var currid=this.$store.state.jobdo.currjob;
        let reponse=await this.$store.dispatch({
          type:'fsadjustline/delitem',
          data:{Id:id,ProjectId:currid}
        });
        if(reponse.success){
          this.$message({
                message: '删除成功',
                type: 'success'
              });
            (this.$refs[this.formRef] as any).resetFields();
            this.tableData=[];
            this.$emit('input',false);
            this.$emit('save-success');
        }
    }
    async created(){
        await this.getitem();
        await this.getacctname();
        await this.getdata();
    }
    updated() {
      const that=this;
      if(that.tableData.length>0){
        that.$nextTick(() => {
          (that.$refs.adjustTable as any).doLayout();
        });
      }
    }
    async save() {
      (this.$refs[this.formRef] as any).validate(async (valid) => {
          if (valid) {
            let data=this.tableData;
            if(data.length==0){
              this.$message({
                message: '请添加分录',
                type: 'warning'
              });
            }
            else{
              try {
                data.forEach(item=>{
                if(item.rId==""||item.rId=="0")
                {
                  this.$message({
                    message: '请选择报表项',
                    type: 'warning'
                  });
                  throw Error();
                }
              })
              } catch (e) {
                return false;
              }
              
              if(this.sumflag){
                this.isLoading=true;
                var currid=this.$store.state.jobdo.currjob;
                let data=JSON.stringify(this.tableData);

                let response=await this.$store.dispatch({
                  type:'fsadjustline/save',
                  data:{Id:this.currentModel.adjid,ProjectId:currid,AdjType:this.currentModel.adjtype,AdjNum:this.currentModel.adjno,AdjLines:data}
                });

                if(response.success){
                  this.$message({
                    message: '保存成功',
                    type:'success'
                  });
                  this.isLoading=false;
                  (this.$refs[this.formRef] as any).resetFields();
                   this.tableData=[];
                   this.$emit('input',false);
                  this.$emit('save-success');
                }
                else{
                  this.$message({
                    message: response.message,
                    type:'error'
                  });
                  this.isLoading=false;
                }
              }
              else{
                this.$message({
                message: '借贷合计不相等',
                type: 'warning'
              });
              }
            }            
          } else {
            return false;
          }
      });
      
    }
  }
  